import { type FC, type HTMLAttributes } from "react";

import classnames from "classnames";

import { useDrawer } from "../providers";

import styles from "../Drawer.module.scss";

type DrawerBackdropProps = HTMLAttributes<HTMLDivElement>;

export const DrawerBackdrop: FC<DrawerBackdropProps> = (props) => {
  const { isOpen, closeDrawer } = useDrawer();

  return (
    <div
      className={classnames(styles.drawerBackdrop, {
        [styles.isOpen]: isOpen,
      })}
      data-testid="drawer-overlay"
      onClick={closeDrawer}
      {...props}
    />
  );
};

DrawerBackdrop.displayName = "DrawerBackdrop";
